import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { ThemeProvider } from './contexts/ThemeContext'
import { ApiLogsProvider } from './contexts/ApiLogsContext'
import { ToastProvider } from './components/ui/ToastProvider'
import HomePage from './pages/HomePage'
import APIExplorerPage from './pages/APIExplorerPage'
import USPSetupPage from './pages/USPSetupPage'
import USPFlowerStorePage from './pages/USPFlowerStorePage'
import USPSdkDemoPage from './pages/USPSdkDemoPage'
import PaymentConfirmationPage from './pages/PaymentConfirmationPage'
import OrderSuccessPage from './pages/OrderSuccessPage'
import FinalOrderConfirmationPage from './pages/FinalOrderConfirmationPage'
import MomentPerksPage from './pages/MomentPerksPage'
import MomentsGalleryPage from './pages/MomentsGalleryPage'
import MomentsExampleOrderThankYouPage from './pages/MomentsExampleOrderThankYouPage'
import MomentCustomizationPage from './pages/MomentCustomizationPage'
import ProductSelectionPage from './pages/ProductSelectionPage'
import StoreCheckoutPage from './pages/StoreCheckoutPage'
import OrderConfirmationPage from './pages/OrderConfirmationPage'
import PaymentInfoPage from './pages/PaymentInfoPage'
import CustomerSupportPage from './pages/CustomerSupportPage'
import NotFoundPage from './pages/NotFoundPage'
import ThemeToggle from './components/ThemeToggle'

const App: React.FC = () => {
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  return (
    <ThemeProvider>
      <ApiLogsProvider>
        <ToastProvider>
          <div className="min-h-screen">
            {/* Only show floating theme toggle on home page */}
            {isHomePage && <ThemeToggle />}
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/api-explorer" element={<APIExplorerPage />} />
                <Route path="/usp-setup" element={<USPSetupPage />} />
                <Route path="/usp-demo" element={<USPFlowerStorePage />} />
                <Route path="/usp-sdk-demo" element={<USPSdkDemoPage />} />
                <Route path="/moment-perks" element={<MomentPerksPage />} />
                <Route path="/moments-gallery" element={<MomentsGalleryPage />} />
                <Route path="/customer-support" element={<CustomerSupportPage />} />
                <Route path="/moments-example-order-thank-you" element={<MomentsExampleOrderThankYouPage />} />
                <Route path="/moment-customization" element={<MomentCustomizationPage />} />
                <Route path="/product-selection" element={<ProductSelectionPage />} />
                <Route path="/store-checkout" element={<StoreCheckoutPage />} />
                <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
                <Route path="/payment-confirmation" element={<PaymentConfirmationPage />} />
                <Route path="/order-success" element={<OrderSuccessPage />} />
                <Route path="/final-confirmation" element={<FinalOrderConfirmationPage />} />
                <Route path="/payment-info" element={<PaymentInfoPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
          </div>
        </ToastProvider>
      </ApiLogsProvider>
    </ThemeProvider>
  )
}

export default App
